import React from 'react';
import { CartItemContainer } from '../../containers/cart-item.jsx';
import { CartItem } from './cart-item.jsx';

export const CartItems = ({ items }) => (
  <div className='cart-popup__items'>
    {items.map((item) => (
      <CartItemContainer
        key={item.key}
        item={item}
        Component={CartItem}
      />
    ))}
  </div>
);
